export default __webpack_public_path__ + "static/media/bg-login.03205897.svg";